import { render, staticRenderFns } from "./ProjectsClassic.vue?vue&type=template&id=a5d4f4c2&scoped=true"
import script from "./ProjectsClassic.vue?vue&type=script&lang=js"
export * from "./ProjectsClassic.vue?vue&type=script&lang=js"
import style0 from "./ProjectsClassic.vue?vue&type=style&index=0&id=a5d4f4c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../mbp_crm-adminclient-golive1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5d4f4c2",
  null
  
)

export default component.exports